import { Box, Button, Grid } from '@mui/material'
import EventTabs from '../Components/Events/ViewEvents/EventTabs'
import { useAppDispatch, useAppSelector, store } from '../redux/store'
import { backgroundColors } from '../Components/Common/Color/Color'
import { useEffect, useState } from 'react'
import EventFilter from '../Components/Events/ViewEvents/EventFilter'
import SearchInput from '../Components/Common/SearchInput'
import RefreshIcon from '@mui/icons-material/Refresh'

import { fetchTeamMemberEvent } from '../redux/event/teamMemberEvents/action'
import { setRegisteredFilters, setUnregisteredFilters } from '../redux/event/teamMemberEvents/slice'
import { selectRegisteredFilters } from '../redux/event/teamMemberEvents/selector'

import { EventFilters } from '../redux/event/teamMemberEvents/types'
import { selectUserTeamMemberInfo } from '../redux/auth/selector'

const ViewEventPage = () => {
  const dispatch = useAppDispatch()

  const teamMemberInfo = useAppSelector(selectUserTeamMemberInfo)
  const [searchQuery, setSearchQuery] = useState<string>('')

  const fetchData = async () => {
    try {
      await dispatch(
        fetchTeamMemberEvent({
          teamMemberWorkdayId: teamMemberInfo.workdayId,
          teamMemberEmail: teamMemberInfo.email,
        }),
      )
    } catch (error) {
      console.error('Error fetching team member events:', error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [dispatch])

  const handleRefreshData = async () => {
    fetchData()
  }

  const handleFilterChange = (selectedFilters: Record<string, string[]>) => {
    const newFilters: EventFilters = {
      category: selectedFilters.Category || [],
      days: selectedFilters.Days ? parseInt(selectedFilters.Days[0]) : 0,
    }
    dispatch(setRegisteredFilters(newFilters))
    dispatch(setUnregisteredFilters(newFilters))
  }

  const handleSearchChange = (query: string) => {
    setSearchQuery(query)
    const currentFilters = selectRegisteredFilters(store.getState())
    const searchFilter: EventFilters = {
      ...currentFilters,
      searchQuery: query,
    }
    dispatch(setRegisteredFilters(searchFilter))
    dispatch(setUnregisteredFilters(searchFilter))
  }

  const handleClearSearch = () => {
    setSearchQuery('')
    const currentFilters = selectRegisteredFilters(store.getState())
    const clearedFilters: EventFilters = {
      ...currentFilters,
      searchQuery: undefined,
    }
    dispatch(setRegisteredFilters(clearedFilters))
    dispatch(setUnregisteredFilters(clearedFilters))
  }

  return (
    <>
      <Box
        component='div'
        sx={{ p: 0, backgroundColor: backgroundColors.white, width: 'auto' }}
        borderRadius={2}
        boxShadow={1}
      >
        <Grid
          container
          sx={{ p: 2 }}
          flexDirection='row'
          alignItems={'center'}
          justifyContent='flex-end'
        >
          <Grid container spacing={2} alignItems='center' display='flex'>
            <Grid>
              <Button
                id='refresh-button'
                color='success'
                startIcon={<RefreshIcon />}
                onClick={handleRefreshData}
                size='small'
              >
                Refresh
              </Button>
            </Grid>

            <Grid>
              <EventFilter onFilterChange={handleFilterChange} />
            </Grid>
            <Grid>
              <SearchInput
                searchQuery={searchQuery}
                onSearchChange={handleSearchChange}
                onClearSearch={handleClearSearch}
              />
            </Grid>
          </Grid>
        </Grid>
        <Box>
          <EventTabs />
        </Box>
      </Box>
    </>
  )
}

export default ViewEventPage
